export const urlApi = process.env.REACT_APP_API_URL;
export const urlApiHttp = process.env.REACT_APP_API_URL_HTTP;
export const urlApiData = process.env.REACT_APP_API_URL_DATA;
export const apiKeyData = process.env.REACT_APP_API_KEY_DATA;

export const urlApiDataCRGCI = process.env.REACT_APP_API_URL_DATA_CRGCI;
export const apiKeyDataCRGCI = process.env.REACT_APP_API_KEY_DATA_CRGCI;

export const urlApiDataEsg = process.env.REACT_APP_API_URL_DATA_ESG;
export const apiKeyDataEsg = process.env.REACT_APP_API_KEY_DATA_ESG;

export const urlApiDataFintech = process.env.REACT_APP_API_URL_DATA_FINTECH;
export const apiKeyDataFintech = process.env.REACT_APP_API_KEY_DATA_FINTECH;

export const urlApiDataTehnology =
  process.env.REACT_APP_API_URL_DATA_TEHNOLOGIE;
export const apiKeyDataTehnology =
  process.env.REACT_APP_API_KEY_DATA_TEHNOLOGIE;

export const getFintechTrendsCount =
  process.env.REACT_APP_API_GET_FINTECH_TRENDS_COUNT;

export const urlMockImageCards = `${urlApi}/api/static/image.png`;
